
export class HeaderConstants {
  static IGNORE_CONTENT_TYPE = 'X-ignore-content-type';
  static SKIP_AUTH = 'X-skip-auth';
  static CACHED = 'X-cached';
}
